import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { TopbarWidget } from './components/topbarwidget.component';
//import { HeroWidget } from './components/herowidget';
//import { FeaturesWidget } from './components/featureswidget';
//import { HighlightsWidget } from './components/highlightswidget';
//import { PricingWidget } from './components/pricingwidget';
import { FooterWidget } from './components/footerwidget';
import { AuthService } from '@/app/features/authentication/services/auth.service';
import { AppFloatingConfigurator } from "@/app/core/auth-layout/component/app.floatingconfigurator";

@Component({
    selector: 'app-landing',
    standalone: true,
    imports: [RouterModule, RippleModule, StyleClassModule, ButtonModule, DividerModule,],
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class Landing {
    private readonly auth = inject(AuthService);
    router = inject(Router);

    readonly authenticated = this.auth.authenticatedSignal;
    
    public login(): void {
        void this.router.navigate(['/login']);
    }
}
